import { GroupStore } from '@yarmill/types';
import { useGroupsStore } from './use-group-store';

export function useGroup(groupId: number | null): GroupStore | undefined {
  return useGroupsStore().getGroupById(groupId);
}
